export default __webpack_public_path__ + "static/media/tangguo.2f9fa6d4.png";